<template>
  <section class="asc-pdf-content">
    <v-navigation-drawer
      v-if="bookmarks.length"
      absolute
      permanent
      :class="[
        'asc-pdf-content--menu',
        stickyMenu ? 'asc-pdf-content--menu-sticky' : null,
      ]"
      :width="menuWidth"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        :color="getColor"
        :height="4"
      ></v-progress-linear>
      <div
        v-if="loading"
        :class="[
          bookmarks && bookmarks.length && loading
            ? 'asc-pdf-content--menu-loading'
            : null,
        ]"
      ></div>
      <asc-side-navigation
        v-model="bookmarkSelection"
        :side-items="bookmarks"
      />
    </v-navigation-drawer>

    <v-container
      :class="[
        'fill-height asc-pdf-content--container',
        bookmarks.length ? 'asc-pdf-content--container-hasMenu' : null,
      ]"
      :style="{
        'padding-left': !stickyMenu
          ? `${menuWidth + 5}px`
          : bookmarks.length
          ? `${0}px`
          : 0,
        width:
          bookmarks && bookmarks.length
            ? `calc(100% - ${menuWidth}px)`
            : '100%',
      }"
    >
      <pdf
        v-for="i in pageCount"
        :id="i"
        :key="i"
        class="asc-pdf-content--container-page"
        :page="i"
        :src="src"
        @page-loaded="handleLoaded"
        @error="error"
      />
    </v-container>
  </section>
</template>

<script>
import AscSideNavigation from '@/components/molecules/AscSideNavigation'
import pdf from 'vue-pdf'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscPdfContentViewer',

  components: {
    AscSideNavigation,
    pdf,
  },

  props: {
    pdfDocument: {
      type: String,
      required: true,
    },
    stickyMenu: {
      type: Boolean,
      default: true,
    },
    menuWidth: {
      type: Number,
      default: 220,
    },
  },

  data() {
    return {
      bookmarks: [],
      bookmarkSelection: 0,
      loadedDocument: null,
      loading: false,
      pageCount: 0,
      page: 1,
      src: null,
    }
  },

  computed: {
    getColor() {
      return variables.accent500
    },
  },

  watch: {
    async bookmarkSelection(newValue) {
      await this.bookmarks.forEach((item, index) => {
        if (index === newValue && item.destination) {
          this.getPageNumber(item.destination)
        }
      })
    },
    page(newPage) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(newPage)) ||
        (document.getElementById(newPage + 1) &&
          window.pageYOffset >=
            this.findPos(document.getElementById(newPage + 1)))
      ) {
        document.getElementById(newPage).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }
    },
  },

  created() {
    if (this.pdfDocument) this.src = pdf.createLoadingTask(this.pdfDocument)
  },
  async mounted() {
    if (this.pdfDocument) {
      this.loading = true
      await this.src.promise.then(pdf => {
        this.loadedDocument = pdf
        this.getBookMarks(pdf)
      })
    }
  },

  destroyed() {
    this.src = null
  },

  methods: {
    async getBookMarks(pdf) {
      await pdf.getOutline().then(outline => {
        if (outline?.length) {
          this.bookmarks = outline.map(item => {
            return {
              destination: item.dest,
              isMenuItem: true,
              title: item.title,
            }
          })
        }
      })
      this.pageCount = pdf.numPages
    },
    async getPageNumber(destination) {
      await this.loadedDocument
        .getPageIndex(destination[0])
        .then(pageNumber => (this.page = pageNumber + 1))
    },
    findPos(obj) {
      return obj.offsetTop
    },
    handleLoaded(pageLoaded) {
      if (pageLoaded === this.pageCount) {
        this.loading = false
      }
    },
    error(err) {
      console.error(err)
    },
  },
}
</script>

<style lang="scss">
.asc-pdf-content {
  min-height: 400px;
  width: 100%;
  position: relative;
  display: flex;

  &--container {
    min-height: 400px;
    height: 100%;
    width: 100%;
    padding: 0;
    margin-left: 0;
    position: relative;

    &-page {
      height: 100%;
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      margin: auto;
      right: 0;
    }
  }

  &--menu {
    height: 100%;

    &-sticky {
      position: sticky;
      overflow: scroll;
    }

    .asc-tabs.asc-vertical-tabs .v-slide-group__wrapper {
      padding-top: 10px;

      .asc-tab-title--vertical.v-tab--active {
        width: 100%;
      }
    }

    .v-navigation-drawer__border {
      width: 0;
    }

    &-loading {
      background-color: rgba(255, 255, 255, 0.5);
      position: absolute;
      height: calc(100% - 5px);
      left: 0;
      top: 5px;
      width: 100%;
      z-index: 1;
    }
  }
}
</style>
